import { buildPopoutURL } from './urlParamsHelper';

export const popoutChatWindow = (
  origin,
  websiteToken,
  locale,
  conversationCookie
) => {
  const windowUrl = buildPopoutURL({
    origin,
    websiteToken,
    locale,
    conversationCookie,
  });
  const popoutWindow = window.open(
    windowUrl,
    `webwidget_session_${websiteToken}`,
    'resizable=off,width=400,height=600'
  );
  popoutWindow?.focus();
};
